import React from "react";
import { Alert, Button, TrashIcon } from "@picklebet/ui";
import { triggerHaptic } from "@/utilities/haptics";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import { useSubmitBet } from "@/features/betslip/hooks/useSubmitBet";
import { SlideOut } from "@/features/betslip/components/overlays/SlideOut";

import * as styles from "@/features/betslip/components/overlays/Duplicate.module.scss";

export const Duplicate = () => {
  const clearSelections = useBetslipStore((s) => s.clearSelections);
  const setOverlay = useBetslipStore((s) => s.setOverlay);
  const cancelConfirm = useBetslipStore((s) => s.cancelConfirm);
  const submission = useBetslipStore((s) => s.submission);
  const submitBet = useSubmitBet();
  const isSubmitting = submission.phase === "submitting";

  // Dismissing the prompt restarts the two-tap flow from Place Bet —
  // otherwise the footer sits on Confirm and the next tap just re-runs
  // the same duplicate check.
  const handleDismiss = () => {
    setOverlay({ type: "none" });
    cancelConfirm();
  };

  const handleClear = () => {
    clearSelections();
    handleDismiss();
    triggerHaptic.error();
  };

  const handleContinue = () => {
    setOverlay({ type: "none" });
    submitBet({ acceptDuplicate: true });
    triggerHaptic.click();
  };

  return (
    <SlideOut onClose={handleDismiss}>
      <Alert
        className={styles.alert}
        color="warning"
        data-testid="overlay-duplicate"
      >
        <span data-testid="duplicate-message">Repeat your last bet?</span>
      </Alert>
      <div className={styles.footer}>
        <Button
          variant="blurred"
          className={styles.iconButton}
          onClick={handleClear}
          data-testid="duplicate-clear"
        >
          <TrashIcon />
        </Button>
        <Button
          loading={isSubmitting}
          variant="warning"
          className={styles.button}
          onClick={handleContinue}
          data-testid="duplicate-continue"
        >
          Continue
        </Button>
      </div>
    </SlideOut>
  );
};
